import React, { useMemo } from 'react';
import NavigationModel from '../../../../components/CustomNavigation/NavigationModel';
import { isSameUserType } from '../../../../utils/helperFunction';
import { crmTypes, croTypeNames } from '../../../../utils/employeeTypes';

const ExpenseNavigation = () => {
  const phpNavigationUrl = process.env.REACT_APP_PHP_URL;
  const currentYear = new Date().getFullYear();
  const currentMonth = new Date().getMonth() + 1;
  const cred = localStorage.getItem('cred');
  const role = cred ? JSON.parse(cred)?.profile?.role : null;
  const loginedUserType = useMemo(() => {
    const crm = isSameUserType({ roleArray: crmTypes, role: role });
    const cro = isSameUserType({ roleArray: croTypeNames, role: role });
    return crm ? 'CRM' : cro ? 'CRO' : 'PM';
  }, [role]);

  let redirectUrl;
  if (loginedUserType === 'CRM') {
    redirectUrl = `${phpNavigationUrl}/expense/crm_approval/${currentYear}/${currentMonth}`;
  } else if (loginedUserType === 'CRO') {
    redirectUrl = `${phpNavigationUrl}/expense/index/2`;
  } else {
    redirectUrl = `${phpNavigationUrl}/expense/crm_approval/${currentYear}/${currentMonth}`;
  }
  return <NavigationModel redirectUrl={redirectUrl} title="Expense" navigationTo={'Old Portal'} />;
};

export default ExpenseNavigation;
